import React from "react";
import { RatingBadge } from "./Reviews";
import { Link } from "react-router-dom";
import { api, Product } from "../lib/api";
import { money } from "../lib/format";
import { usePick } from "./PickMode";

export function ProductCard({ product, index = 0 }: { product: Product; index?: number }) {
  const pick = usePick();
  return (
    <div className="relative">
    {pick.userId && (
      <button onClick={async (e) => { e.preventDefault(); const p: Product = product.variants.length ? product : (await api.get(`/catalog/products/${product.handle}`)).data; const v = p.variants.find((x) => x.available) || p.variants[0]; if (v) pick.add(p, v); }} className="absolute right-2 top-2 z-10 bg-[var(--wine)] px-3 py-1.5 text-xs uppercase tracking-widest text-[var(--paper)] shadow hover:bg-[var(--ink)]" data-testid={`pick-add-${product.handle}`}>+ Add to case</button>
    )}
    <Link to={`/shop/${product.handle}`} className="group rise block" style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }} data-testid={`product-card-${product.handle}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-[var(--parchment)]">
        {product.image ? (
          <img src={product.image} alt={product.title} loading="lazy" className="h-full w-full object-contain transition-transform duration-700 ease-out group-hover:scale-105" />
        ) : (
          <div className="flex h-full items-center justify-center font-serif text-neutral-400">No image</div>
        )}
        {!product.available && <span className={`absolute left-3 top-3 px-2 py-1 text-[10px] uppercase tracking-widest text-[var(--paper)] ${(product.tags || []).includes("coming-soon") ? "bg-[var(--moss)]" : "bg-[var(--ink)]"}`} data-testid={`product-stock-badge-${product.handle}`}>{(product.tags || []).includes("coming-soon") ? "Coming soon" : "Sold out"}</span>}
      </div>
      <div className="mt-4">
        <div className="eyebrow truncate">{product.vendor || product.product_type}</div>
        <div className="mt-1 flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-3">
          <h3 className="min-w-0 font-serif text-base leading-tight transition-colors duration-200 group-hover:text-[var(--wine)] sm:text-lg">{product.title}</h3>
          <div className="shrink-0 text-sm font-medium tabular-nums leading-tight" data-testid="product-card-price">{money(product.price_min_pence)}</div>
        </div>
        <div className="mt-1"><RatingBadge productId={product.id} /></div>
      </div>
    </Link>
    </div>
  );
}
